import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import DropdownButton from './DropdownButton.jsx';
import { useUserInfoQuery } from '../lib/Queries';
import { post, userApiRoute } from '../lib/Api';
import PencilSquareIcon from './icons/PencilSquareIcon';
import {
    BeakerIcon,
    ChevronDownIcon,
} from '@heroicons/react/24/outline/index.js';
import BusinessLogoSmall from './BusinessLogoSmall.jsx';
import { getBrowserTimezone } from '../lib/DateTime.js';
import useCreateBusiness from '../lib/useCreateBusiness.jsx';
import { truncate } from '../lib/Utils.js';
import NewBusiness2025 from '~/components/onboarding/NewBusiness2025';
import LogoutIcon from '~/components/icons/LogoutIcon.jsx';

const BusinessSwitcher = ({ currentBusiness, businessNameClassName }) => {
    const navigate = useNavigate();
    const [showNewBusiness, setShowNewBusiness] = useState(false);
    const { data, isLoading } = useUserInfoQuery();
    const businesses = data?.businesses || [];

    const menuOptions = [
        ...businesses
            .sort((a, b) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            )
            .map(b => ({
                name: (
                    <span>
                        {b.name}
                        {b.id === currentBusiness?.id ? (
                            <span className="text-gray-500 ml-1">
                                (current)
                            </span>
                        ) : (
                            ''
                        )}
                    </span>
                ),
                //`${b.name}${b.id === currentBusiness?.id ? ' (current)' : ''}`,
                onClick: () => {
                    navigate(`/business/${b.id}`);
                    return true;
                },
            })),
        {
            name: 'Create New Business',
            onClick: () => {
                setShowNewBusiness(true);
                return true;
            },
            icon: <PencilSquareIcon className="text-primary-700" />,
            className: 'text-primary-700',
        },
        {
            name: 'Log out',
            onClick: () => {
                if (confirm('Are you sure you want to log out?')) {
                    navigate('/logout');
                }
            },
            icon: <LogoutIcon className="text-primary-700" />,
            className: 'text-primary-700',
        },
    ];

    const isLongName = currentBusiness?.name?.length > 20;

    return (
        <>
            <DropdownButton
                options={menuOptions}
                btnClassName={``}
                menuItemsClassName={'left-6 max-h-[430px] overflow-scroll'}
                btnContent={
                    <div
                        className={`px-0 ${isLongName ? 'text-base' : 'text-lg'} no-underline text-gray-700 flex gap-2 justify-between`}
                    >
                        <span>
                            <div className="flex gap-2 items-center">
                                <BusinessLogoSmall
                                    business={currentBusiness}
                                />
                                <div className={businessNameClassName}>
                                    {truncate(currentBusiness?.name || '', 20)}
                                </div>
                            </div>
                        </span>
                        <span className="text-gray-500 text-sm mt-1">
                            <ChevronDownIcon className="w-5 h-5" />
                        </span>
                    </div>
                }
            />
            <NewBusiness2025
                onClose={() => setShowNewBusiness(false)}
                isOpen={showNewBusiness}
            />
        </>
    );
};

export default BusinessSwitcher;
